import { Injectable } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Filter } from './models/filter';
import { filter } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class FiltersPanelService {

	private showPanel$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private filters$: BehaviorSubject<Array<Filter>> = new BehaviorSubject<Array<Filter>>([]);
	private applyPanel$: Subject<boolean> = new Subject<boolean>();

	constructor(private router: Router) {
		this.router.events
			.pipe(filter((event: Event) => event instanceof NavigationEnd))
			.subscribe(() => {
				this.setShowPanel(false);
				this.setFilters([]);
			});
	}

	getShowPanel(): Observable<boolean> {
		return this.showPanel$.asObservable();
	}

	setShowPanel(showHide: boolean): void {
		this.showPanel$.next(showHide);
	}

	togglePanelState(): void {
		this.showPanel$.next(!this.showPanel$.value);
	}

	isPanelOpen(): boolean {
		return this.showPanel$.value;
	}

	getFilters(): Observable<Array<Filter>> {
		return this.filters$.asObservable();
	}

	setFilters(filters: Array<Filter>): void {
		this.filters$.next(filters);
	}

	getApplyPanel(): Observable<any> {
		return this.applyPanel$.asObservable();
	}

	setApplyPanel(apply: boolean): void {
		this.applyPanel$.next(apply);
	}
}